import React from 'react';
import styles from '../css/Details_Affiliations.module.css';
import firstCapital from '../../../helper/firstCapital';
import hcp from '../../../lookup/hcp.json'
import Icon from '../../../components/Icon/Icon';
import { useFeatureFlags } from '../../../hooks/useFeatureFlags';

const AFFILIATIONS_EDIT_DERM_TEAMS = ['31', '33', '34', '35', '53', '81', '82'];

function Details_Affiliations(props) {
    const { AffiliationsEditDermTeamsAccess } = useFeatureFlags();
    if (!props.data) { return null; }

    let displayRes = []
    for (let i = 0; i < props.data.length; i++) {
        let style = i % 2 === 0 ? [styles.Content, styles.Odd].join(' ') : styles.Content
        displayRes.push([
            <div key={i} className={styles.Results}>
                <div className={style}>{firstCapital(props.data[i].ORG_NAME)}</div>
                <div className={style}>{props.data[i].ORG_TYPE}</div>
                <div className={style}>{`${firstCapital(props.data[i].ADDRESS1)} ${firstCapital(props.data[i].ADDRESS2)}, ${firstCapital(props.data[i].CITY)}, ${props.data[i].STATE}, ${props.data[i].ZIP5}`}</div>
                <div className={style}>{props.data[i].PROF_COUNT}</div>
                <div className={style}>{props.data[i].ADD_DATE ? props.data[i].ADD_DATE.replace(/[Tt].*/, "") : ""}</div>
            </div>
        ])
    }

    let affiliationsView = hcp.details.affiliations.view
    let affiliationsEdit = hcp.details.affiliations.edit
    let isAdmin = props.user.role.includes("ADMIN")
    // Edit Affiliations is disabled for DERM teams regardless of role match,
    // unless AffiliationsEditDermTeamsAccess is flipped on (Admins are unaffected).
    let hasAffiliationsEditTeamAccess = AffiliationsEditDermTeamsAccess || !AFFILIATIONS_EDIT_DERM_TEAMS.includes(props.user.team)
    let canEditAffiliations = isAdmin || (hasAffiliationsEditTeamAccess && (affiliationsEdit.teams.includes(props.user.team) || affiliationsEdit.roles.includes(props.user.role)))
    let affiliations = ((props.user.role.includes("PRT") || props.user.role.includes("COMMERCIAL DERM") || props.user.isDermAdmin == 'true' || (isAdmin || affiliationsView.teams.includes(props.user.team) || affiliationsEdit.teams.includes(props.user.team)) || (affiliationsView.roles.includes(props.user.role) || affiliationsEdit.roles.includes(props.user.role))) && props.user.role != 'PHARMFORCE') ?
    (<div className={styles.Affiliations}>
        <div className={styles.AffiliationsTopBar}>
            <div>Affiliations</div>
            {
                canEditAffiliations ? (<div className={styles.AffiliationsEditButton}>
                    <Icon name="edit" onClick={() => { props.editScreen(9);}} style={{cursor:"pointer"}} />
                </div>) : ""
            }
        </div>
        <div className={styles.titles}>
            <div className={styles.Title}>ORG NAME</div>
            <div className={styles.Title}>ORG TYPE</div>
            <div className={styles.Title}>ADDRESS</div>
            <div className={styles.Title}>AFFILIATED PROF COUNT</div>
            <div className={styles.Title}>LAST MODIFIED</div>
        </div>
        <div className={styles.ResultsWrapper}>
            {
                props.data.length > 0 ?
                displayRes
                :
                <div className={styles.Results}>
                    <div className={[styles.Content, styles.Odd].join(' ')}>—</div>
                    <div className={[styles.Content, styles.Odd].join(' ')}>—</div>
                    <div className={[styles.Content, styles.Odd].join(' ')}>—</div>
                    <div className={[styles.Content, styles.Odd].join(' ')}>—</div>
                    <div className={[styles.Content, styles.Odd].join(' ')}>—</div>
                </div>
            }
        </div>
    </div>) : ""

    return affiliations;
}

export default Details_Affiliations;
